import React, {useState} from 'react'
import {useIntl} from 'react-intl'
import {Button} from '../../../../../_gori/partials/widgets'
import RequestBase from '../../../../api/RequestBase'
import {isValidZip, handleZipChange, normalizeZip} from '../../core/shippingCalculatorHelpers'

export function UspsZoneCalculator() {
  const intl = useIntl()

  const [fromZip, setFromZip] = useState('')
  const [toZip, setToZip] = useState('')
  const [result, setResult] = useState<{zone: string} | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const onZipChange = (set: (v: string) => void) => (raw: string) => {
    set(handleZipChange(raw))
    if (result) setResult(null)
    if (error) setError(null)
  }

  const calculate = async () => {
    setResult(null)
    setError(null)
    if (!isValidZip(fromZip) || !isValidZip(toZip)) {
      setError(intl.formatMessage({id: 'ERROR_FILL_SHIPPING_FIELDS'}))
      return
    }
    setLoading(true)
    try {
      const res = await RequestBase.get(
        `/tools/usps-zone?from_zip=${encodeURIComponent(
          normalizeZip(fromZip)
        )}&to_zip=${encodeURIComponent(normalizeZip(toZip))}`
      )
      setResult(res)
    } catch {
      setResult(null)
      setError(intl.formatMessage({id: 'ERROR_INFO_NOT_FOUND'}))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='d-flex flex-column gap-6 align-items-center w-100'>
      <div className='shipping-calc__tool-desc-box'>
        <h3 className='fw-bolder fs-4 mb-4'>
          {intl.formatMessage({id: 'USPS_ZONE_CALCULATOR_TITLE'})}
        </h3>
        <p className='fs-6 mb-0 text-gray-700'>
          {intl.formatMessage({id: 'USPS_ZONE_CALCULATOR_DESC'})}
        </p>
      </div>
      <form
        className='shipping-calc__tool-input-box d-flex flex-column gap-4'
        onSubmit={(e) => {
          e.preventDefault()
          calculate()
        }}
      >
        <div className='d-flex gap-3'>
          <div className='d-flex flex-column gap-3 flex-fill'>
            <label
              htmlFor='usps-zone-from'
              className='fw-bolder fs-4 lh-base shipping-calc__input-title'
            >
              {intl.formatMessage({id: 'ORIGIN_ZIP'})}
            </label>
            <input
              id='usps-zone-from'
              type='text'
              inputMode='numeric'
              maxLength={10}
              className='form-control bg-white'
              placeholder={intl.formatMessage({id: 'FROM_ZIP'})}
              aria-label={intl.formatMessage({id: 'ORIGIN_ZIP'})}
              value={fromZip}
              onChange={(e) => onZipChange(setFromZip)(e.target.value)}
            />
          </div>
          <div className='d-flex flex-column gap-3 flex-fill'>
            <label
              htmlFor='usps-zone-to'
              className='fw-bolder fs-4 lh-base shipping-calc__input-title'
            >
              {intl.formatMessage({id: 'DESTINATION_ZIP'})}
            </label>
            <input
              id='usps-zone-to'
              type='text'
              inputMode='numeric'
              maxLength={10}
              className='form-control bg-white'
              placeholder={intl.formatMessage({id: 'TO_ZIP'})}
              aria-label={intl.formatMessage({id: 'DESTINATION_ZIP'})}
              value={toZip}
              onChange={(e) => onZipChange(setToZip)(e.target.value)}
            />
          </div>
        </div>
        <Button
          classNameDiv='w-100'
          className='shipping-calc__calculate-btn w-100 fs-4 border-0 text-white d-flex justify-content-center align-items-center'
          submit
          loading={loading}
          label={intl.formatMessage({id: 'FIND_USPS_ZONE'})}
          loadingText={intl.formatMessage({id: 'CALCULATING'})}
        />
      </form>
      {error && (
        <div className='shipping-calc__error-module' role='alert'>
          {error}
        </div>
      )}
      {result && (
        <div className='shipping-calc__result-module' aria-live='polite'>
          <span className='shipping-calc__result-label'>
            {intl.formatMessage({id: 'USPS_ZONE'})}{' '}
          </span>
          <span className='shipping-calc__result-value'>{result.zone}</span>
        </div>
      )}
    </div>
  )
}
